import { useState } from "react";
import { useTours } from "@/lib/siteData";
import { useAdminBookings, rpc, money, fmtDateTime, STATUS } from "@/lib/booking";
import { Card, Field, PageTitle, Ok, Err, useAction, smallBtn } from "./adminUI";

function groupCustomers(bookings) {
    const map = {};
    for (const b of bookings) {
        const k = b.customer_email.toLowerCase();
        const c = (map[k] ||= { email: k, name: b.customer_name, phone: b.customer_phone, bookings: [], paid: 0 });
        c.bookings.push(b);
        c.paid += Number(b.paid_amount) - Number(b.refunded_amount);
    }
    return Object.values(map).sort((a, b) => b.bookings[0].created_at.localeCompare(a.bookings[0].created_at));
}

export default function CustomersAdmin({ role }) {
    const bookings = useAdminBookings();
    const tours = Object.fromEntries(useTours(true).map((t) => [t.id, t.title]));
    const [q, setQ] = useState("");
    const [open, setOpen] = useState("");
    const { run, busy, msg, err } = useAction();
    const list = groupCustomers(bookings.data || []).filter((c) => !q || `${c.name} ${c.email} ${c.phone}`.toLowerCase().includes(q.toLowerCase()));

    return (
        <div className="space-y-6">
            <PageTitle title="Clientes">Dados restritos a administradores (RLS). Use apenas para atendimento.</PageTitle>
            <Card><Field label="Pesquisar" value={q} onChange={setQ} testid="customers-search" /></Card>
            <div className="flex gap-3"><Ok msg={msg} /><Err msg={err} /></div>
            {list.map((c) => (
                <Card key={c.email} className="space-y-2">
                    <div className="flex flex-wrap items-center justify-between gap-3" data-testid={`customer-row-${c.email}`}>
                        <div><strong>{c.name}</strong><p className="text-xs text-dim">{c.email} · {c.phone}</p></div>
                        <span className="text-xs text-dim">{c.bookings.length} reserva(s) · pago {money(c.paid)}</span>
                    </div>
                    <div className="flex gap-2">
                        <button className={smallBtn} onClick={() => setOpen(open === c.email ? "" : c.email)}>Histórico</button>
                        {role === "owner" && <button className={smallBtn} disabled={busy} data-testid={`customer-anonymize-${c.email}`}
                            onClick={() => window.confirm("Anonimizar os dados pessoais deste cliente (LGPD)? Esta ação não pode ser desfeita.") && run(() => rpc("admin_anonymize_customer", { p_email: c.email }), "Dados anonimizados")}>Anonimizar (LGPD)</button>}
                    </div>
                    {open === c.email && c.bookings.map((b) => (
                        <p key={b.id} className="text-xs text-dim">{b.code} · {tours[b.tour_id] || "—"} · {fmtDateTime(b.created_at)} · {STATUS[b.status]} · {money(b.total)}</p>
                    ))}
                </Card>
            ))}
        </div>
    );
}
